export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'splitBilling';
export const NAME = 'SplitBilling';
export const COLUMN_SHARE_PERCENTAGE = 'SHARE_PERCENTAGE';
export const COLUMN_DISCOUNT_PERCENT = 'DISCOUNT_PERCENT';
export const COLUMN_DISCOUNT_AMOUNT = 'DISCOUNT_AMOUNT';
export const SPLIT_PARTY = 'SplitParty';
export const CUSTOMER_ID = 'CustomerId';
export const CUSTOMER = 'Customer';
export const DEALER = 'Dealer';
export const PRIMARY_CUSTOMER_ROW_INDEX = 0;
export const DEFAULT_SHARE_PERCETAGE = 0;
export const MAX_SHARE_PERCETAGE = 100;
export const PARTS = 'PARTS';
export const LABOUR = 'LABOUR';
export const EXTLABOUR = 'EXTLABOUR';
export const DEFAULT = 'DEFAULT';
export const DEFAULT_INDEX = 0;
export const DEFAULT_ID = 1;
export const SPLIT_PARTIES = {
	Warranty: 'Warranty',
	Goodwill: 'Goodwill',
	Internal: 'Internal',
	Insurance: 'Insurance',
	Corporate: 'Corporate',
	Individual: 'Individual',
};
